/* QUANTICA · Tarjeta del producto girando, en el hero del home.

   El video se reproduce solo, en loop y sin controles: es una pieza de
   producto, no un contenido que alguien decida mirar. Eso trae dos deberes
   que el HTML no cubre solo, y son las dos unicas cosas que hace este
   archivo.

   1. QUIEN PIDIO MENOS MOVIMIENTO NO LO VE MOVERSE. El atributo autoplay no
      entiende de prefers-reduced-motion, asi que hay que frenarlo a mano y
      dejar el primer cuadro quieto, que sigue mostrando el producto.

   2. FUERA DE PANTALLA NO CORRE. Un loop de nueve segundos decodificando a
      lo largo de toda la pagina gasta bateria en el telefono sin que nadie
      lo vea. Con IntersectionObserver se pausa al salir y vuelve al entrar.

   Si el navegador rechaza el autoplay —pasa cuando el sistema esta en modo
   de ahorro— queda el poster, que es un cuadro del propio video. No hay
   estado roto posible. */
(function () {
  'use strict';

  if (customElements.get('q-hero-spin')) return;

  var QUIETO = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  class QHeroSpin extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      if (QUIETO && QUIETO.matches) {
        this.frenar();
        return;
      }

      // El cambio de preferencia en vivo tambien cuenta: alguien que la
      // activa mientras mira la pagina no deberia tener que recargar.
      if (QUIETO && QUIETO.addEventListener) {
        this.alCambiar = function (e) {
          if (e.matches) this.frenar();
        }.bind(this);
        QUIETO.addEventListener('change', this.alCambiar);
      }

      if (!('IntersectionObserver' in window)) return;

      this.ojo = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(
            function (e) {
              if (QUIETO && QUIETO.matches) return;
              if (e.isIntersecting) {
                // play() devuelve una promesa que se rechaza si el navegador
                // bloquea la reproduccion. Sin el catch queda un error suelto
                // en la consola en cada scroll.
                var p = this.video.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                this.video.pause();
              }
            }.bind(this)
          );
        }.bind(this),
        { rootMargin: '200px' }
      );
      this.ojo.observe(this);
    }

    frenar() {
      this.video.removeAttribute('autoplay');
      this.video.pause();
    }

    disconnectedCallback() {
      if (this.ojo) this.ojo.disconnect();
      if (this.alCambiar && QUIETO && QUIETO.removeEventListener) {
        QUIETO.removeEventListener('change', this.alCambiar);
      }
    }
  }

  customElements.define('q-hero-spin', QHeroSpin);
})();
